import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { Markdown } from './Markdown';

const sample: Dictionary<{ short: string; long: string }> = {
  pl: {
    short: 'Uruchom w **DBWorkspace**. Język `en_us` zostaje -- reszta znika.',
    long: '## Nagłówek\n\nAkapit z **pogrubieniem**, *kursywą*, [linkiem](/library) i `kodem`.\n\n- pierwszy punkt\n- drugi punkt\n\n> Cytat w jednej linii.\n\n<b>Surowy HTML</b> zostaje tekstem.',
  },
  en: {
    short:
      'Run it in **DBWorkspace**. The `en_us` language stays -- the rest goes.',
    long: '## Heading\n\nA paragraph with **bold**, *italics*, a [link](/library) and `code`.\n\n- first item\n- second item\n\n> A one-line quote.\n\n<b>Raw HTML</b> stays text.',
  },
};

export default {
  kind: 'component',
  title: { pl: 'Markdown', en: 'Markdown' },
  description: {
    pl: 'Markdown renderowany w przeglądarce, bez surowego HTML. Bez propsów zostaje goły, do wstawienia w cudzy tekst; z `prose` dostaje typografię dłuższego tekstu.',
    en: "Markdown rendered in the browser, without raw HTML. Bare by default, for dropping into someone else's text; with the `prose` prop it is typeset as long-form text.",
  },
  variants: [
    {
      name: { pl: 'Goły', en: 'Bare' },
      render: (locale) => <Markdown>{sample[locale].short}</Markdown>,
    },
    {
      name: { pl: 'Typografia', en: 'Typeset' },
      render: (locale) => <Markdown prose>{sample[locale].long}</Markdown>,
    },
  ],
} satisfies Story;
